import React from 'react';
import { LuCheck, LuX, LuListChecks } from 'react-icons/lu';

// Selección múltiple (11-oct-2026). Botón para entrar, casilla por fila y barra de
// acciones fija abajo. sobreNav: deja lugar a la barra de abajo de la app del admin.

export function BotonSeleccionar({ activo, onClick }) {
    return (
        <button type="button" onClick={onClick} aria-pressed={activo}
            className={`h-10 px-3 rounded-xl inline-flex items-center gap-1.5 text-label font-black active:scale-95 ${activo ? 'bg-ink text-page' : 'bg-chip text-secondary'}`}>
            <LuListChecks size={16} /> {activo ? 'Listo' : 'Seleccionar'}
        </button>
    );
}

// Envuelve una fila: en modo selección muestra la casilla y el toque tilda en vez de abrir
export function Tildable({ activo, tildado, onAlternar, children }) {
    if (!activo) return children;
    return (
        <div role="checkbox" aria-checked={tildado} tabIndex={0}
            onClick={onAlternar} onKeyDown={e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); onAlternar(); } }}
            className={`relative flex items-stretch gap-2.5 rounded-2xl cursor-pointer select-none ${tildado ? 'ring-2 ring-[#C9341F]' : ''}`}>
            <span className={`self-center ml-1 w-6 h-6 shrink-0 rounded-full border-2 flex items-center justify-center ${tildado ? 'bg-[#C9341F] border-[#C9341F] text-white' : 'border-black/25 dark:border-white/30'}`}>
                {tildado && <LuCheck size={14} strokeWidth={3} />}
            </span>
            <div className="flex-1 min-w-0 pointer-events-none">{children}</div>
        </div>
    );
}

export function BarraSeleccion({ cantidad, total, onTodos, onSalir, acciones = [], sobreNav = false }) {
    const todos = total > 0 && cantidad === total;
    return (
        <div className={`fixed inset-x-0 z-[60] px-3 pointer-events-none ${sobreNav ? 'bottom-[calc(76px+env(safe-area-inset-bottom))] md:bottom-6' : 'bottom-[calc(12px+env(safe-area-inset-bottom))]'}`}>
            <div className="max-w-xl mx-auto pointer-events-auto rounded-2xl bg-card shadow-2xl border border-black/[0.08] dark:border-white/[0.1] p-2.5 space-y-2">
                <div className="flex items-center gap-2">
                    <button type="button" onClick={onSalir} aria-label="Salir de la selección"
                        className="w-9 h-9 shrink-0 rounded-xl bg-chip text-muted flex items-center justify-center"><LuX size={16} /></button>
                    <p className="flex-1 text-body font-black text-ink">{cantidad} seleccionado{cantidad !== 1 ? 's' : ''}</p>
                    {total > 0 && <button type="button" onClick={onTodos} className="h-9 px-3 rounded-xl bg-chip text-label font-black text-secondary">{todos ? 'Ninguno' : `Todos (${total})`}</button>}
                </div>
                {acciones.length > 0 && (
                    <div className="flex gap-2">
                        {acciones.map(a => (
                            <button key={a.label} type="button" onClick={a.onClick} disabled={a.disabled || cantidad === 0}
                                className={`flex-1 h-11 px-2 rounded-xl text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95 disabled:opacity-40 ${a.peligro ? 'bg-[#C9341F] text-white' : a.principal ? 'bg-ink text-page' : 'bg-chip text-ink'}`}>
                                {a.Icon && <a.Icon size={15} />}{a.label}{cantidad > 0 ? ` (${a.cantidad ?? cantidad})` : ''}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
